/* eslint-disable react/no-unknown-property */
import React, { useEffect, useRef } from 'react';
import proptypes from 'prop-types';

const { string } = proptypes;

// Viewport-relative heights: the iframe fills the overlay minus the header chrome.
// No Stencil token expresses calc(100vh - Npx), so these stay arbitrary values.
// Portrait phones/tablets (<1024px) reserve more room for the taller header.
const IFRAME_CLASSES = 'sui-overflow-hidden sui-w-full sui-h-[calc(100vh-60px)] '
  + 'portrait:max-lg:sui-h-[calc(100vh-100px)]';

export const AvataarIFrame = ({ avataarExperienceLink = '' }) => {
  const avataarRef = useRef(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && window && window.XRIFrame && avataarRef?.current?.id) {
      window.XRIFrame.registerXRIFrame('avtrIframe');
    }
  }, [avataarRef]);

  return (
    <iframe
      ref={avataarRef}
      id="avtrIframe"
      title="Avataar Iframe"
      src={avataarExperienceLink}
      margintop="0"
      frameBorder="10"
      className={IFRAME_CLASSES}
      allow="camera;microphone;gyroscope;accelerometer;"
    />
  );

};

AvataarIFrame.propTypes = {
  avataarExperienceLink: string
};

export default AvataarIFrame;
